/**
 * Mapea nodo de expresión del DTO (snake_case) al modelo front (camelCase).
 * Recursivo en children.
 */
export const expressionNodeFromDto = (dto) => {
  if (!dto) return null;
  return {
    id: dto.id,
    nodeType: dto.node_type,
    operationType: dto.operation_type ?? null,
    valueType: dto.value_type ?? null,
    valueName: dto.value_name ?? null,
    fixedValue: dto.fixed_value != null ? Number(dto.fixed_value) : null,
    order: dto.order,
    children: (dto.children ?? []).map(expressionNodeFromDto),
  };
};

/**
 * Mapea cálculo del DTO al modelo front.
 */
export const calculationFromDto = (dto) => {
  if (!dto) return null;
  return {
    id: dto.id,
    calculationType: dto.calculation_type,
    expression: expressionNodeFromDto(dto.expression),
  };
};

/**
 * Mapea nodo de expresión del front (camelCase) al DTO (snake_case).
 * Recursivo en children. Asegura order 1-based consecutivo en children.
 */
export const expressionNodeToDto = (node) => {
  if (!node) return null;
  const base = {
    node_type: node.nodeType,
    order: node.order ?? 1,
  };
  if (node.nodeType === 'operation') {
    return {
      ...base,
      operation_type: node.operationType,
      children: (node.children ?? []).map((child, index) =>
        expressionNodeToDto({ ...child, order: index + 1 })
      ),
    };
  }
  if (node.nodeType === 'value') {
    const valueDto = {
      ...base,
      value_type: node.valueType,
      value_name: node.valueName ?? undefined,
      fixed_value: node.fixedValue != null && node.fixedValue !== '' ? node.fixedValue : undefined,
    };
    return valueDto;
  }
  return base;
};

/**
 * Payload para crear cálculo (POST).
 */
export const calculationCreateToDto = (data) => ({
  calculation_type: data.calculationType ?? 'premium',
  expression: expressionNodeToDto(data.expression),
});

/**
 * Payload para actualizar cálculo (PUT). Solo expression.
 */
export const calculationUpdateToDto = (data) => ({
  expression: expressionNodeToDto(data.expression),
});
